import React, { useState, useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { toast } from 'react-toastify';

const SendOtp = ({ onResend = () => {} , OTPSent=false}) => {
  const [counter, setCounter] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [otpLabel, setOtpLabel] = useState('Send OTP');

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      setOtpLabel('Resend OTP');
      setIsButtonDisabled(false);
    }
    return () => clearInterval(timer);
  }, [counter]);
  
  const handleResendOtp = () => {
    onResend();
  };
  useEffect(() => {
    if(OTPSent) {
      setCounter(60);
      setIsButtonDisabled(true);
      setOtpLabel('Resend OTP');
    }
  }, [OTPSent]);

  return (
    <Stack
      spacing={1}
      direction={'row'}
      alignItems={'center'}
      alignContent={'center'}
    >
      {isButtonDisabled && (
        <Typography variant='subtitle2'>
          Resend OTP in {counter} seconds
        </Typography>
      )}
      {!isButtonDisabled && (
        <Button
          variant='text'
          color='primary'
          onClick={handleResendOtp}
          disabled={isButtonDisabled}
          sx={{ cursor : 'pointer'}}
        >
          {otpLabel}
        </Button>
      )}
      
    </Stack>
  );
};

export default SendOtp;
